import {
  Typography,
} from "@visma-netvisor/react-component-library";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useServiceNeedContext } from "../../../context/ServiceNeedContext";
import LabeledOption from "../../LabeledOption";

const labeledOptionConfigs = [
  {
    name: "hasInsurance",
    labelKey: "OnlineStatus.AlreadyPurchased",
    setter: (context: ReturnType<typeof useServiceNeedContext>) => context.setHasInsurance
  },
  {
    name: "insuranceServiceNeed",
    labelKey: "OnlineStatus.PossiblyYesShareContactToInsurance",
    setter: (context: ReturnType<typeof useServiceNeedContext>) => context.setInsuranceServiceNeed
  },
];

const InsuranceServiceNeedPage = () => {
  const context = useServiceNeedContext();
  const { t } = useTranslation();

  return (
    <>
      <StyledTypography
        as="h3"
        color="secondary"
        variant="headingH4Regular"
        styleOverrides={{ paddingTop: 20, paddingBottom: 10 }}
      >
        {t("OnlineStatus.WhatIsTheStatusOfInsurance")}
      </StyledTypography>
      {labeledOptionConfigs.map(({ name, labelKey, setter }, index) => (
        <LabeledOption
          key={`${name}-${index}`}
          name={name}
          labelKey={labelKey}
          onChange={e => setter(context)(e.target.checked)}
          type="checkbox" 
        />
      ))}
    </>
  )
}

export default InsuranceServiceNeedPage;

const StyledTypography = styled(Typography)`
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;